import { Translation } from '@openng/optimus-ui/api';

// Component labels of Optimus UI (date pickers, filters, empty states…), English is built in
export const OPTIMUS_FR: Translation = {
  dayNames: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
  dayNamesShort: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
  dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
  monthNames: [
    'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
    'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre',
  ],
  monthNamesShort: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
  firstDayOfWeek: 1,
  dateFormat: 'dd/mm/yy',
  weekHeader: 'Sem.',
  today: "Aujourd'hui",
  clear: 'Effacer',
  accept: 'Oui',
  reject: 'Non',
  choose: 'Choisir',
  upload: 'Envoyer',
  cancel: 'Annuler',
  apply: 'Appliquer',
  addRule: 'Ajouter une règle',
  removeRule: 'Supprimer la règle',
  matchAll: 'Tous les critères',
  matchAny: "Au moins un critère",
  noFilter: 'Aucun filtre',
  emptyMessage: 'Aucun résultat',
  emptyFilterMessage: 'Aucun résultat',
  emptySearchMessage: 'Aucun résultat',
  emptySelectionMessage: 'Aucun élément sélectionné',
  selectionMessage: '{0} élément(s) sélectionné(s)',
  searchMessage: '{0} résultat(s) disponible(s)',
  weak: 'Faible',
  medium: 'Moyen',
  strong: 'Fort',
  passwordPrompt: 'Saisissez un mot de passe',
  pending: 'En attente',
  fileSizeTypes: ['o', 'Ko', 'Mo', 'Go', 'To', 'Po', 'Eo', 'Zo', 'Yo'],
};
